<template lang="pug">
.w-btn-volume( @mouseleave='closeVolume' )
  transition( name='fade-superfast' mode='out-in' )
    w-btn-icon(
      v-if=`iconPos === 'before'`
      :key='icon'
      :size='size'
      :hoverAction='openVolume'
      hover
      @click='toggleMute'
    )
      component( :is='icon' :title='title' )
  w-slider.volume(
    no-labels
    :max='100'
    :format='( x ) => `${x}%`'
    :value='value * 100'
    :class=`{ open: volumeOpen }`
    @input='setVolume'
  )
  transition( name='fade-superfast' mode='out-in' )
    w-btn-icon(
      v-if=`iconPos === 'after'`
      :key='icon'
      :size='size'
      :hoverAction='openVolume'
      hover
      @click='toggleMute'
    )
      component( :is='icon' :title='title' )
</template>

<script lang="js">
import WBtnIcon from './w-btn-icon'
import WSlider from './w-slider'
import IVolumeLow from 'icons/VolumeLow'
import IVolumeMed from 'icons/VolumeMedium'
import IVolumeHigh from 'icons/VolumeHigh'
import IVolumeOff from 'icons/VolumeOff'

export default {
  name: 'VolumeButtonWidget',
  mixins: [],
  components: {
    WBtnIcon,
    WSlider,
    IVolumeLow,
    IVolumeMed,
    IVolumeHigh,
    IVolumeOff,
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    muted: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'lg'
    },
    noHover: {
      type: Boolean,
      default: true
    },
    iconPos: {
      type: String,
      default: 'after'
    }
  },
  data() {
    return {
      volumeOpen: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    toggleMute() {
      this.$emit( this.action )
    },
    setVolume( $event ) {
      this.$emit( 'input', Math.round( $event ) / 100 )
    },
    openVolume() {
      this.volumeOpen = true
    },
    closeVolume() {
      this.volumeOpen = false
    },
  },
  computed: {
    action() {
      return this.muted ? 'unmute' : 'mute'
    },
    icon() {
      return this.muted ? 'i-volume-off'
         : this.value > 0.66 ? 'i-volume-high'
         : this.value > 0.33 ? 'i-volume-med'
         : 'i-volume-low'
    },
    title() {
      return this.muted ? 'Unmute' : 'Mute'
    }
  }
}
</script>

<style lang="scss">
.w-btn-volume {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 50%;
  .volume {
    margin-left: 2em;
    transition: width 250ms, opacity 250ms;
    width: 0;
    opacity: 0;
    flex: 1;
    &.open {
      width: 8em;
      opacity: 1;
    }
  }
}
</style>
